import { createAction, props } from '@ngrx/store';
import { CompanyListFeatureState, CompanyListGridData } from './company-list.models';

const snapshotPersisted = createAction(
  '[Company List] Snapshot persisted',
  props<{ snapshot: Omit<CompanyListFeatureState, 'gridData'> }>()
);

const gridDataCached = createAction(
  '[Company List] Grid data cached',
  props<{ gridData: CompanyListGridData }>()
);

const gridDataCleared = createAction('[Company List] Grid data cleared');

const cleared = createAction('[Company List] Cleared');

export const CompanyListActions = {
  snapshotPersisted,
  gridDataCached,
  gridDataCleared,
  cleared
};
